import { KpkFilterType } from "@keepeek/commons";
import { KSplitValue } from "@keepeek/refront-components";
import { TFunction } from "i18next";

export function getKSplitValueTranslation(
  kSplitValueKey: KSplitValue | undefined,
  t: TFunction,
): KSplitValue {
  const kSplitValue: KSplitValue = { id: "", label: "", type: KpkFilterType.Text };
  if (kSplitValueKey && kSplitValueKey.label) {
    if (t(kSplitValueKey.label) !== kSplitValueKey.label) {
      kSplitValue.id = kSplitValueKey.id;
      kSplitValue.label = t(kSplitValueKey.label);
      kSplitValue.type = kSplitValueKey.type;
    } else {
      kSplitValue.id = kSplitValueKey.id;
      kSplitValue.label = t("search.input.split.item.label", {
        field: kSplitValueKey.label,
      }).toUpperCase();
      kSplitValue.type = kSplitValueKey.type;
    }
  }
  return kSplitValue;
}
